const initHeadings = headings => {
  if (!headings) {
    return;
  }

  [...headings].forEach( heading => {
    heading.innerHTML = heading.innerHTML.replace( 'Secure2Go', '<strong class="s2g-stylized">Secure<span>2</span>Go</strong>' );
  } );
};

export default initHeadings;
